module.exports = __webpack_public_path__ + "files/berger.fc24adc0dd4d59aeaf1938cbf1942809.pdf";